import find from 'lodash/find';
import includes from 'lodash/includes';

import { IAutoQuote, IVehicle } from '../../../interfaces';
import getLatestDataOrders from '../getLatestDataOrders';

export default function getQuoteHealthStatus(
  quote: IAutoQuote,
  ineligibleDriverIds: (string | number)[],
  ineligibleVehicleIds: string[]
) {
  const vehiclesList = quote?.application?.vehicles || [];
  const driversList = (quote?.application?.drivers || []).filter(
    (driver) => !driver.is_excluded
  );

  const noVinVehicleList = vehiclesList.filter((vehicle) => !vehicle.vin);
  const requiresLienholderVehicle = find(
    vehiclesList,
    (vehicle: IVehicle) =>
      vehicle.ownership_status !== 'owned' &&
      (!vehicle.lienholder ||
        !vehicle.lienholder.address ||
        !vehicle.lienholder.name)
  );
  const driverWithoutLicenseInfo = find(
    driversList,
    (driver) =>
      driver.role === 'driver' &&
      (!driver.driving_license_number || !driver.driving_license_state)
  );
  const pniDriverWithoutLicenseInfo = find(
    driversList,
    (driver) =>
      driver.role === 'pni' &&
      (!driver.driving_license_number || !driver.driving_license_state)
  );
  const hasIneligibleDriver = !!find(driversList, (driver) =>
    includes(ineligibleDriverIds, driver.id)
  );

  const isPNIIneligible = !!find(
    driversList,
    (driver) =>
      driver.role === 'pni' && includes(ineligibleDriverIds, driver.id)
  );

  const hasIneligibleVehicle = !!find(vehiclesList, (vehicle) =>
    includes(ineligibleVehicleIds, vehicle.id)
  );
  const successfulOrders = (
    quote?.application?.metadata?.third_party_data_orders || []
  ).filter((order = {}) => order.status === 'success');

  const latestSuccessfulOrders = getLatestDataOrders(successfulOrders);

  return {
    isMissingVins: !!noVinVehicleList.length,
    isMissingLienholder: !!requiresLienholderVehicle,
    isMissingLicenseInfo:
      !!driverWithoutLicenseInfo || !!pniDriverWithoutLicenseInfo,
    isOnlyPNIMissingLicenseInfo:
      !!pniDriverWithoutLicenseInfo && !driverWithoutLicenseInfo,
    successfulOrders: latestSuccessfulOrders,
    hasIneligibleDriver,
    isPNIIneligible,
    hasIneligibleVehicle,
  };
}
